import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const AdminStats = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState([]);

  const getApiUrl = (endpoint) => {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192');
    return isLocal ? `http://${window.location.hostname}:3001${endpoint}` : endpoint;
  };

  useEffect(() => {
    const fetchStats = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await fetch(getApiUrl('/api/stats'), {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setStats(data);
        }
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    };
    fetchStats();
  }, []);

  return (
    <div>
      <h2>{t('blog.statsTitle')}</h2>
      <div className="table-responsive" style={{marginTop: '20px'}}>
        <table className="qso-table" style={{width: '100%'}}>
          <thead>
            <tr>
              <th>{t('blog.page')}</th>
              <th>{t('blog.views')}</th>
              <th>{t('blog.lastVisit')}</th>
            </tr>
          </thead>
          <tbody>
            {stats.map((stat, index) => (
              <tr key={index}>
                <td>{stat.page}</td>
                <td><strong>{stat.count}</strong></td>
                <td>{new Date(stat.lastVisited).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminStats;